module.exports = __webpack_public_path__ + "static/img/son4.42b53ad9.png";